import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: RouteConfig[] = [
  {
    path: "/datasets/:parent_id/create",
    name: "dataset_create",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.dataset.create" */ "../views/DatasetCreate.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/datasets/:id",
    name: "dataset",
    component: safeImport(
      () =>
        import(/* webpackChunkName: "route.dataset" */ "../views/Dataset.vue")
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/datasets/:dataset_id/history",
    name: "dataset_history",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.dataset.history" */ "../views/DatasetHistory.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/datasets/:dataset_id/versions/:version_id",
    name: "dataset_version",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.datasets.version" */ "../views/DatasetVersion.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
  {
    path: "/office-premium",
    name: "office_premium",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.office-premium" */ "../views/OnlyOfficePremium.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
];

export default routes;
